<!--Driver Analysis Modal-->
@if (showDriverAnalysisModal) {
  <app-lex-xi-modal
    [isVisible]="showDriverAnalysisModal"
    maxWidth="900px"
    (close)="onDriverAnalysisDialogClosed()"
  >
    <ng-template appXIModalContent>
      @if (showDriverAnalysisModal) {
        <app-driver-analysis-dialog
          [data]="driverAnalysisModalData"
          (modalClosed)="onDriverAnalysisDialogClosed($event)"
        ></app-driver-analysis-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}

<!-- Rename Collection Modal -->
@if (showRenameCollectionModal) {
  <app-lex-xi-modal
    [isVisible]="showRenameCollectionModal"
    maxWidth="418px"
    (close)="onRenameCollectionDialogClosed()"
  >
    <ng-template appXIModalContent>
      <app-rename-collection
        [collections]="projectCollections"
        [collectionName]="currentCollection.data.collectionName"
        (modalClosed)="onRenameCollectionDialogClosed($event)"
      ></app-rename-collection>
    </ng-template>
  </app-lex-xi-modal>
}

<!--Select Smart Summary Scene Modal-->
@if (showSceneSelectModal) {
  <app-lex-xi-modal
    [isVisible]="showSceneSelectModal"
    maxWidth="720px"
    (close)="onSceneSelectDialogClosed()"
  >
    <ng-template appXIModalContent>
      @if (showSceneSelectModal) {
        <app-collection-scene-select-dialog
          [data]="sceneSelectModalData"
          (modalClosed)="onSceneSelectDialogClosed($event)"
        ></app-collection-scene-select-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (showUploadInfoModal) {
  <app-lex-xi-modal
    [isVisible]="showUploadInfoModal"
    maxWidth="700px"
    (close)="onUploadInfoModalClosed()"
  >
    <ng-template appXIModalContent>
      @if (showUploadInfoModal) {
        <app-upload-info
          [options]="uploadInfoOptions"
          (modalClosed)="onUploadInfoModalClosed()"
        ></app-upload-info>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (isAnalysisDialogOpen) {
  <app-lex-xi-modal
    [isVisible]="isAnalysisDialogOpen"
    maxWidth="900px"
    (close)="onCloseNewAnalysisDialog(null)"
  >
    <ng-template appXIModalContent>
      @if (isAnalysisDialogOpen) {
        <app-new-analysis
          [groupConfigurations]="groupConfigurations"
          [collection]="collectionForAnalysisDialog"
          [projectId]="project.id"
          [analysis]="projectItemForAnalysisDialog?.analysis"
          (modalClosed)="onCloseNewAnalysisDialog($event)"
        ></app-new-analysis>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (isSelectCollectionConfigurationDialogOpen) {
  <app-lex-xi-modal
    [isVisible]="isSelectCollectionConfigurationDialogOpen"
    maxWidth="800px"
    (close)="onCloseSelectCollectionConfigurationDialog(null)"
  >
    <ng-template appXIModalContent>
      @if (isSelectCollectionConfigurationDialogOpen) {
        <app-select-collection-configuration-dialog
          [collection]="collectionForSelectCollectionConfigurationDialog"
          (modalClosed)="onCloseSelectCollectionConfigurationDialog($event)"
        ></app-select-collection-configuration-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (isCalculatedFieldConfigModalOpen) {
  <app-lex-xi-modal
    [isVisible]="isCalculatedFieldConfigModalOpen"
    maxWidth="600px"
    (close)="onCloseCalculatedFieldConfigModal()"
  >
    <ng-template appXIModalContent>
      @if (isCalculatedFieldConfigModalOpen) {
        <app-calculated-field-config-modal
          [collection]="calculatedFieldCollection"
          (modalClosed)="onCloseCalculatedFieldConfigModal()"
        ></app-calculated-field-config-modal>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (isCollectionSettingsOpen) {
  <app-lex-xi-modal
    [isVisible]="isCollectionSettingsOpen"
    maxWidth="600px"
    (close)="onCloseCollectionSettings()"
  >
    <ng-template appXIModalContent>
      @if (isCollectionSettingsOpen) {
        <app-upload-create
          [project]="collectionSettingsProject"
          [collection]="collectionSettingsCollection"
          (close)="onCloseCollectionSettings()"
        ></app-upload-create>
      }
    </ng-template>
  </app-lex-xi-modal>
}
